module.exports = __webpack_public_path__ + "static/media/testowomen.1982f700.png";